export default "__VITE_ASSET__DHmEnOTm__"